import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@chakra-ui/icons";
import { Flex, IconButton, Text, Tooltip } from "@chakra-ui/react";

type PaginationProps = {
  pageIndex: number;
  setNextPageIndex: any;
  setPrevPageIndex: any;
  pageSize?: any;
  setPageSize?: any;
  jumpToPage: any;
  numberOfPages?:number;
};

export function Pagination({
  pageIndex,
  setNextPageIndex,
  setPrevPageIndex,
  jumpToPage,
  numberOfPages=1,
}: PaginationProps) {
  return (
    <>
      <Flex justifyContent="flex-end" m={4} alignItems="center" gap={1}>
        <Flex>
          <Tooltip label="Première page">
            <IconButton
              onClick={() => jumpToPage(1)}
              // isDisabled={!canPreviousPage}
              aria-label={"First page"}
              icon={<ArrowLeftIcon h={3} w={3} />}
              mr={4}
            />
          </Tooltip>
          <Tooltip label="Page précédente">
            <IconButton
              onClick={setPrevPageIndex}
              // isDisabled={!canPreviousPage}
              icon={<ChevronLeftIcon h={6} w={6} />}
              aria-label={"Page précédente"}
            />
          </Tooltip>
        </Flex>

        <Flex justifyContent="space-between" m={4} alignItems="center">
          <Text flexShrink="0" mr={8}>
            Page{" "}
            <Text fontWeight="bold" as="span">
              {pageIndex}
            </Text>{" "}
            /{" "}
            <Text fontWeight="bold" as="span">
              {numberOfPages}
            </Text>
          </Text>
        </Flex>

        <Flex>
          <Tooltip label="Page suivante">
            <IconButton
              onClick={setNextPageIndex}
              // isDisabled={!canNextPage}
              icon={<ChevronRightIcon h={6} w={6} />}
              aria-label={"Page suivante"}
            />
          </Tooltip>
          <Tooltip label="Dernière page">
            <IconButton
              onClick={() => jumpToPage(numberOfPages)}
              // isDisabled={!canNextPage}
              icon={<ArrowRightIcon h={3} w={3} />}
              ml={4}
              aria-label={"Dernière page"}
            />
          </Tooltip>
        </Flex>
      </Flex>
    </>
  );
}
